module.exports = __webpack_public_path__ + "tmp_node_modules/js-tabs/dist/main/.css.liquid";


//////////////////
// WEBPACK FOOTER
// ./node_modules/js-tabs/dist/main/js-tabs-base.css
// module id = 349
// module chunks = 0